var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.1296 25.5916H29.5334V14.9953C29.5334 13.9068 28.651 13.0244 27.5625 13.0244H14.9953C13.9068 13.0244 13.0244 13.9068 13.0244 14.9953V40.1296C13.0244 41.2181 13.9068 42.1005 14.9953 42.1005H40.1296C41.2181 42.1005 42.1005 41.2181 42.1005 40.1296V27.5625C42.1005 26.4739 41.2181 25.5916 40.1296 25.5916ZM25.5916 29.5334V38.1587H16.9662V29.5334H25.5916ZM25.5916 25.5916H16.9662V16.9662H25.5916V25.5916ZM38.1587 29.5334V38.1587H29.5334V29.5334H38.1587ZM52.6966 22.4498C51.6081 22.4498 50.7257 23.3321 50.7257 24.4207V47.984C50.7257 49.4983 49.4982 50.7258 47.9839 50.7258H7.14093C5.62665 50.7258 4.39912 49.4982 4.39912 47.984V7.14103C4.39912 5.62675 5.62664 4.39923 7.14093 4.39923H30.7042C31.7927 4.39923 32.6751 3.51684 32.6751 2.42832C32.6751 1.33981 31.7927 0.457422 30.7042 0.457422H7.14093C3.44972 0.457422 0.457422 3.44972 0.457422 7.14093V47.984C0.457422 51.6752 3.44972 54.6675 7.14093 54.6674H47.984C51.6752 54.6674 54.6675 51.6751 54.6675 47.9839V24.4207C54.6675 23.3321 53.7851 22.4498 52.6966 22.4498Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3118 1.92422H42.3992C40.8036 1.92422 39.5102 3.21769 39.5102 4.8133V12.7259C39.5102 14.3215 40.8036 15.615 42.3992 15.615H50.3118C51.9074 15.615 53.2009 14.3215 53.2009 12.7259V4.8133C53.2009 3.2177 51.9074 1.92422 50.3118 1.92422Z",
    stroke: "#1D4ED8",
    strokeWidth: 3.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIcon3);
export default __webpack_public_path__ + "static/media/about_icon3.430100558d6bb8032eb454d03b4a469e.svg";
export { ForwardRef as ReactComponent };